import React from "react";
import styled from "styled-components";
import { Table as BsTable } from "react-bootstrap";
import { RespuestaLeerPropietarios } from "../../../services/propietariosServicios";
import { useNavigate } from "react-router-dom";
import { RUTA_PROPIETARIOS } from "../../../services/rutas";

interface TableSectionProps {
  propietarios: RespuestaLeerPropietarios[];
}

interface TableItemProps {
  propietario: RespuestaLeerPropietarios;
}

function TableItem({ propietario }: TableItemProps) {
  let navigate = useNavigate();

  return (
    <StyledRow
      onClick={() =>
        navigate(`${RUTA_PROPIETARIOS}/${propietario.id}`, { replace: false })
      }
    >
      <StyledCell>{propietario.documento}</StyledCell>
      <StyledCell>{propietario.nombres}</StyledCell>
      <StyledCell>{propietario.celular}</StyledCell>
      <StyledCell>{propietario.direccion}</StyledCell>
      <StyledCell>{propietario.mascotas.join(", ")}</StyledCell>
    </StyledRow>
  );
}

function Table({ propietarios }: TableSectionProps) {
  return (
    <StyledTable responsive hover>
      <thead>
        <tr>
          <StyledColHeader>Documento</StyledColHeader>
          <StyledColHeader>Nombres</StyledColHeader>
          <StyledColHeader>Celular</StyledColHeader>
          <StyledColHeader>Dirección</StyledColHeader>
          <StyledColHeader>Mascotas</StyledColHeader>
        </tr>
      </thead>
      <tbody>
        {propietarios.map((_, index) => (
          <TableItem key={_.id} propietario={_} />
        ))}
      </tbody>
    </StyledTable>
  );
}

const StyledTable = styled(BsTable)``;

const StyledCell = styled("td")``;

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledRow = styled("tr")`
  cursor: pointer;
`;

export default Table;
